import {
  Component,
  ElementRef,
  HostListener,
  NgZone,
  OnDestroy,
  OnInit,
  ViewChild
} from '@angular/core';
import {Store} from '@ngrx/store';
import {Observable, of} from 'rxjs';
import {
  CitizensServicesCategory
} from 'src/app/store/entities/citizens/citizens-services-category/citizens-services-category.model';
import {
  selectModifiedCitizensServiceCategory
} from 'src/app/store/entities/citizens/citizens-services-category/citizens-services-category.selectors';
import {
  CitizensServicesSector
} from 'src/app/store/entities/citizens/citizens-services-sector/citizens-services-sector.model';
import {
  selectModifiedCitizenSector
} from 'src/app/store/entities/citizens/citizens-services-sector/citizens-services-sector.selectors';
import {AppState} from 'src/app/store/reducers';
import {countAnimation, fadeAnimation, fadeIn, listAnimation} from '../../../shared/animations/basic-animation';
import {FormControl} from '@angular/forms';
import {
  CITIZEN_GET_MOST_POPULAR_SERVICES,
  CITIZEN_GET_SEARCHED_SERVICES,
  GET_LANDING_STATS,
  UPDATE_SEARCHED_SERVICE,
} from './portal-home';
import {Apollo} from 'apollo-angular';
import {CitizensServices} from '../../../store/entities/citizens/citizens-services/citizens-services.model';
import {Router} from '@angular/router';
import {environment} from '../../../../environments/environment';
import {selectMediaImages} from 'src/app/store/entities/media-image/media-image.selectors';
import {MediaImage, PictureTypeEnum,} from 'src/app/store/entities/media-image/media-image.model';
import * as Aos from 'aos';
import {MatAutocompleteSelectedEvent} from "@angular/material/autocomplete";

interface GroupOfService {
  total: number;
  group: string;
}

@Component({
  selector: 'app-portal-home',
  templateUrl: './portal-home.component.html',
  styleUrls: ['./portal-home.component.scss'],
  animations: [listAnimation, fadeAnimation, countAnimation, fadeIn],
})
export class PortalHomeComponent implements OnInit, OnDestroy {
  searchedKeyword = new FormControl('');
  searchedInstitutionKeyword = new FormControl('');
  filteredSearch: Observable<CitizensServices[]>;
  carousels$: Observable<MediaImage[]>;
  fileUrl = environment.FILE_SERVER_URL;

  citizenServicesCategory$: Observable<CitizensServicesCategory[]>;
  citizenServicesCategories: CitizensServicesCategory[][];
  citizenSectors$: Observable<CitizensServicesSector[]>;


  msaadaAiToggle: boolean = false;

  lastShownSectorIndex: number = 0
  @ViewChild('prevBtn', {static: false}) prevBtn: ElementRef;
  @ViewChild('nextBtn', {static: false}) nextBtn: ElementRef;
  @ViewChild('parentSectorCarousel', {static: false}) parentSectorCarousel: ElementRef;
  fileServer: string = environment.FILE_SERVER_URL;
  showBackToTop = false;
  sectorCounts: number = 3;
  activeCitizenSectors: CitizensServicesSector[];
  sectorCarouselItems: CitizensServicesSector[] = []
  activeSectorCarouselItems: CitizensServicesSector[] = []
  activeSectorCarouselItemPage: number = 0
  screenWidth: number;
  wrapper: number = 100
  isVisible: { [key: string]: boolean } = {};
  currentIndex = 0;
  itemsToShow = 12;
  imageIndex = 0
  activeCarouselImage: MediaImage
  serviceCount: number = 0;  // Initial value, replace with your actual value
  totalAutomatedServices: number = 0
  totalInstitutions: number = 0
  totalIntegratedServices: number = 0
  landingStats: {
    totalServices?: number
    totalCitizens?: number
    totalCitizenFeedbacks?: number
    totalInstitutions?: number
    totalIntegratedServices?: number
    totalAutomatedServices?: number
    totalPerGroupOfService?: GroupOfService[]
  }
  active = 1;
  private intervalId: any;
  hoveredMenu:string;

  constructor(
    private store: Store<AppState>,
    private apollo: Apollo,
    private router: Router,
    private ngZone: NgZone
  ) {
    this.screenWidth = window.innerWidth;
    this.calculateSectorCount(this);
  }

  allStats = [];
  activeStats = [];
  slideInterval: any;
  currentStatSlide = 0;

  buildStatsCards() {
    this.allStats = [
      { icon: 'landingDashboard', count: this.landingStats?.totalServices, label: 'Huduma' },
      { icon: 'serviceFeedback', count: this.landingStats?.totalCitizenFeedbacks, label: 'Mrejesho' },
      { icon: 'taasisi', count: this.landingStats?.totalInstitutions, label: 'Total Institutions' },
      { icon: 'data_center', count: this.landingStats?.totalIntegratedServices, label: 'Integrated Services' },
      { icon: 'take_action', count: this.landingStats?.totalAutomatedServices, label: 'Automated Services' },
      ...(this.landingStats?.totalPerGroupOfService || []).map(g => ({
        icon: 'landingDashboard',
        count: g.total,
        label: g.group
      }))
    ];

    this.updateStatCarousel();
  }

  updateStatCarousel() {
    const chunkSize = this.getStatChunkSize();
    const totalSlides = Math.max(1, Math.ceil(this.allStats.length / chunkSize));
    if (this.currentStatSlide >= totalSlides) {
      this.currentStatSlide = 0;
    }
    const start = this.currentStatSlide * chunkSize;
    this.activeStats = this.allStats.slice(start, start + chunkSize);
    this.statCardsKey++;

    this.ngZone.runOutsideAngular(() => {
      requestAnimationFrame(() => {
        setTimeout(() => {
          Aos.refreshHard();
        }, 0);
      });
    });
  }

  getStatChunkSize(): number {
    return this.screenWidth < 768 ? 2 : 4;
  }

  getStatTotalSlides(): number {
    return Math.max(1, Math.ceil(this.allStats.length / this.getStatChunkSize()));
  }

  prevStatsSlide() {
    const totalSlides = this.getStatTotalSlides();
    this.currentStatSlide = (this.currentStatSlide - 1 + totalSlides) % totalSlides;
    this.updateStatCarousel();
  }

  nextStatsSlide() {
    const totalSlides = this.getStatTotalSlides();
    this.currentStatSlide = (this.currentStatSlide + 1) % totalSlides;
    this.updateStatCarousel();
  }


  stopStatsCarousel() {
    if (this.slideInterval) {
      clearInterval(this.slideInterval);
      this.slideInterval = null;
    }
  }

  startStatsCarousel() {
    this.stopStatsCarousel();
    this.slideInterval = setInterval(() => {
      this.nextStatsSlide();
    }, 5000);
  }

  onStatsPanelHover(isHovering: boolean) {
    if (isHovering) {
      this.stopStatsCarousel();
    } else {
      this.startStatsCarousel();
    }
  }
  statCardsKey = 0;



  getCitizenSearchedServices(keyword) {
    this.apollo
      .query({
        query: CITIZEN_GET_SEARCHED_SERVICES,
        fetchPolicy: 'network-only',
        variables: {
          searchKey: keyword,
        },
      })
      .toPromise()
      .then((data) => {
        let result: any = Object.values(data)[0];
        result = result.citizenGetSearchedServices;
        if (result?.response.code == '9000') {
          this.filteredSearch = of(result.data);
        }
      });
  }

  getLandingStats() {
    this.apollo
      .query({
        query: GET_LANDING_STATS,
        fetchPolicy: 'network-only',
      })
      .toPromise()
      .then((data) => {
        let result: any = Object.values(data)[0];
        result = result.getLandingStats;
        if (result?.response.code == '9000') {
          this.landingStats = result.data;
          this.updateAnimatedValue();
          this.buildStatsCards();
          this.startStatsCarousel();
        }
      })
  }


  handleHover(menu) {
    this.hoveredMenu = menu;
  }

  activeMenu(menu) {
    return this.hoveredMenu == menu;
  }




  updateSearchedService(serviceUniqueId) {
    this.apollo
      .mutate({
        mutation: UPDATE_SEARCHED_SERVICE,
        fetchPolicy: 'network-only',
        variables: {
          serviceUniqueId: serviceUniqueId,
        },
      })
      .toPromise()
      .then((data) => {
        let result: any = Object.values(data)[0];
        result = result.citizenUpdateSearchedServiceMutation;
        if (result?.response.code == '9000') {
        }
      });
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    const previousChunkSize = this.getStatChunkSize();
    this.screenWidth = window.innerWidth;
    const currentChunkSize = this.getStatChunkSize();

    if (previousChunkSize !== currentChunkSize) {
      this.currentStatSlide = 0;
      this.updateStatCarousel();
    }

    this.calculateSectorCarouselPage()

    this.calculateSectorCount(this);
  }

  @HostListener('window:scroll', ['$event'])
  onScroll(containerId: string, event: Event, index: number): void {
    const delay = index * 500; // 300 milliseconds delay for each container

    setTimeout(() => {
      this.checkVisibility(containerId);
    }, delay);
  }

  checkVisibility(containerId: string): void {
    const container = document.getElementById(containerId);
    if (!container) return;

    const element = document.querySelector('.fade-in-element');
    if (!element) return;

    const rect = container.getBoundingClientRect();
    this.isVisible[containerId] = rect.top <= window.innerHeight && rect.bottom >= 0;
  }


  calculateSectorCount(context) {
    context.sectorCounts = Math.floor(context.screenWidth / 80 - 2);
  }

  // Example function to update the animated value
  updateAnimatedValue() {
    // Simulate updating the value over time (e.g., with a timer)
    setInterval(() => {
      if (this.serviceCount >= this.landingStats?.totalServices) {
        this.serviceCount = this.landingStats?.totalServices
      } else {
        this.serviceCount += 1; // Adjust this based on your actual logic
      }
    }, 1);
    setInterval(() => {
      if (this.totalAutomatedServices >= this.landingStats?.totalAutomatedServices) {
        this.totalAutomatedServices = this.landingStats?.totalAutomatedServices
      } else {
        this.totalAutomatedServices += 1; // Adjust this based on your actual logic
      }
    }, 1);

    setInterval(() => {
      if (this.totalInstitutions >= this.landingStats?.totalInstitutions) {
        this.totalInstitutions = this.landingStats?.totalInstitutions
      } else {
        this.totalInstitutions += 1; // Adjust this based on your actual logic
      }
    }, 1);

    setInterval(() => {
      if (this.totalIntegratedServices >= this.landingStats?.totalIntegratedServices) {
        this.totalIntegratedServices = this.landingStats?.totalIntegratedServices
      } else {
        this.totalIntegratedServices += 1; // Adjust this based on your actual logic
      }
    }, 1);
  }

  ngOnInit(): void {

    Aos.init()
    // Subscribing to the 'citizenSectors$' observable
    this.citizenSectors$ = this.store.select(selectModifiedCitizenSector);


    this.citizenSectors$.subscribe((sector) => {
      // Checking if 'sector' has a value
      if (sector) {
        // Assigning the entire 'sector' array to 'activeCitizenSectors'
        this.activeCitizenSectors = sector.slice(
          this.currentIndex,
          this.itemsToShow
        );

        this.sectorCarouselItems = sector
        this.calculateSectorCarouselPage()
      }
    });


    this.citizenServicesCategory$ = this.store.select(
      selectModifiedCitizensServiceCategory
    );

    this.citizenServicesCategory$.subscribe((data) => {
      if (data) {
        this.citizenServicesCategories = this.chunkArray(data, 5)
      }
    });

    this.getLandingStats()

    this.carousels$ = this.store.select(
      selectMediaImages(PictureTypeEnum.CAROUSEL)
    );

    this.carousels$.subscribe((carouselImage) => {
      this.activeCarouselImage = carouselImage[this.imageIndex]
    })


    this.intervalId = setInterval(() => {
      this.nextSlide();
    }, 5000);

  }

  @HostListener('window:scroll')
  onWindowScroll(): void {
    this.showBackToTop = window.scrollY > 100;
  }

  scrollToTop(): void {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  scrollToContainer(id: string) {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({behavior: 'smooth'});
    }
  }

  calculateSectorCarouselPage() {
    // this.wrapper = this.screenWidth - (this.prevBtn.nativeElement.offsetWidth * 2) - 10
    this.wrapper = this.screenWidth - 10;

    let totalItemWidths = 0
    this.lastShownSectorIndex = 0
    this.activeSectorCarouselItems = []
    for (const sectorCarouselItem of this.sectorCarouselItems) {
      let width = (sectorCarouselItem?.sectorName?.length * 9) + 32 + 10
      if (this.wrapper > totalItemWidths + width) {
        totalItemWidths += width
        this.activeSectorCarouselItems.push(sectorCarouselItem)
        this.lastShownSectorIndex += 1
      } else {
        break
      }
    }
    this.activeSectorCarouselItemPage = 1
  }

  ngOnDestroy(): void {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
    this.stopStatsCarousel();
  }

  next() {
    // this.wrapper = this.screenWidth - (this.prevBtn.nativeElement.offsetWidth * 2) - 10
    this.wrapper = this.screenWidth - 10

    if (this.lastShownSectorIndex === 0) {
      this.lastShownSectorIndex = this.activeSectorCarouselItems.length
    }
    let totalItemWidths = 0
    this.activeSectorCarouselItems = []
    let items = this.sectorCarouselItems.slice()
    for (const sectorCarouselItem of items.splice(this.lastShownSectorIndex, this.sectorCarouselItems.length)) {
      let width = (sectorCarouselItem.sectorName.length * 9) + 32 + 10
      if (this.wrapper > totalItemWidths + width) {
        totalItemWidths += width
        this.activeSectorCarouselItems.push(sectorCarouselItem)
        this.lastShownSectorIndex += 1
      } else {
        break
      }
    }
    this.activeSectorCarouselItemPage += this.activeSectorCarouselItemPage

  }

  setActiveIndex(index: number): void {
    this.carousels$.subscribe((carouselImage) => {
      if (carouselImage && carouselImage.length > 0) {
        this.imageIndex = index;
        this.updateCarousel(carouselImage);
      }
    });
  }

  nextSlide(): void {
    this.carousels$.subscribe((carouselImage) => {
      if (carouselImage && carouselImage.length > 0) {
        this.imageIndex = (this.imageIndex + 1) % carouselImage.length;
        this.updateCarousel(carouselImage);
      }
    });
  }

  prev() {

    this.wrapper = this.screenWidth - (this.prevBtn.nativeElement.offsetWidth * 2) - 10

    let totalItemWidths = 0
    let sectorCarouselCurrentPageCount = this.activeSectorCarouselItems.length
    this.activeSectorCarouselItems = []
    let items = this.sectorCarouselItems.slice()
    if (this.lastShownSectorIndex === this.sectorCarouselItems.length) {
      this.lastShownSectorIndex -= sectorCarouselCurrentPageCount
    }
    items = items.splice(0, this.lastShownSectorIndex)

    for (let i = items.length - 1; i >= 0; i--) {
      let width = (items[i].sectorName.length * 9) + 32 + 10
      if (this.wrapper > totalItemWidths + width) {
        totalItemWidths += width
        this.activeSectorCarouselItems.push(items[i])
        this.lastShownSectorIndex -= 1
      } else {
        break
      }
    }
    this.activeSectorCarouselItems.reverse()
    this.activeSectorCarouselItemPage -= 1
  }

  updateCarousel(carouselImage: MediaImage[]): void {
    this.activeCarouselImage = carouselImage[this.imageIndex];
  }

  // Helper method to update the 'activeCitizenSectors' based on the current index and sector array
  updateActiveCitizenSectors(sector: CitizensServicesSector[]) {
    const endIndex = (this.currentIndex + this.itemsToShow) % sector.length;
    if (this.currentIndex <= endIndex) {
      this.activeCitizenSectors = sector.slice(this.currentIndex, endIndex);
    } else {
      this.activeCitizenSectors = [
        ...sector.slice(this.currentIndex),
        ...sector.slice(0, endIndex),
      ];
    }
  }

  onSearchChange() {
    if (this.searchedKeyword.value !== '')
      this.getCitizenSearchedServices(this.searchedKeyword.value);
    else this.filteredSearch = of([]);
  }

  onInstitutionSearchChange() {
    if (this.searchedInstitutionKeyword.value !== '') {
      this.handleHover('institution-search');
    }
  }

  onItemSelected(event: MatAutocompleteSelectedEvent) {
    let optionValue = event.option.value.split('*@*');
    this.searchedKeyword.setValue(optionValue[0]);
    this.updateSearchedService(optionValue[1]);
    this.router.navigate([`/service-view/${optionValue[1]}`]);
  }

  chunkArray(arr, size) {
    return arr.reduce((acc, val, i) => {
      const index = Math.floor(i / size);
      const innerArr = acc[index] || [];
      innerArr.push(val);
      acc[index] = innerArr;
      return acc;
    }, []);
  }

  showSlide(idx: number) {
    this.active = idx + 1;
  }

}


